// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DtDf","col":"styles_col__1N-BY"};